import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from "axios";
import { useToastStore } from "@/stores/toastStore.js";

export const useCabinetStore = defineStore('cabinet-store',  () => {

  const toastStore = useToastStore()

  const cabinetId = ref()
  const cabinetData = ref({})

  function setCabinet(newCabinetId) {
    if (newCabinetId) {
      cabinetId.value = newCabinetId
      getCabinetData(newCabinetId)
      // getCabinetPermissions(cabinetId, userId)
    }
    else {
      cabinetId.value = null
      cabinetData.value = {}
      // cabinetPermissions.value = {}
    }
  }

  function getCabinetData(cabinetId) {
    axios.get(`/api/cabinets/${ cabinetId }`).then( r => cabinetData.value = r.data )
  }

  function updateCabinetData(cabinetId, newCabinetData) {
    axios.patch(`/api/cabinets/${ cabinetId }`, newCabinetData).then(r => {
      cabinetData.value = r.data
      toastStore.showToastMessage('Updated cabinet information', 'success', 'add')
    })
  }

  const cabinetColumnConfig = ref([{}])
  function getCabinetColumnConfig(cabinetId) {
    axios.get(`/api/cabinets/${ cabinetId }/column_config`).then( r => cabinetColumnConfig.value = r.data.column_config )
  }
  function updateCabinetColumnConfig(cabinetId, columnChanges) {
    axios.put(`/api/cabinets/${ cabinetId }/column_config`, columnChanges).then(r => {
      cabinetColumnConfig.value = r.data.column_config
    })
  }

  const userColumnConfig = ref([])
  const getUserColumnConfig = async (cabinetId) => {
    const { data } = await axios.get(`/api/cabinets/${cabinetId}/user_column_config`)
    const combinedColumnConfig = mergeReservedColumns(data)

    userColumnConfig.value = combinedColumnConfig
    return combinedColumnConfig
  }
  const saveUserColumnConfig = (state) => {
    const params = {
      cabinet_id: cabinetId.value,
      column_config: state.columns
    }

    axios.post(`/api/cabinets/${cabinetId.value}/user_column_config`, params)
  }

  // ensures reserved columns always appear first in fixed order, then metadata columns
  const reservedDataFields = ['selected', 'doc_title', 'doc_dt', 'page_count', 'has_split']
  const protectedKeys = ['visible', 'fixed', 'allowFixing', 'headerCellTemplate', 'cellTemplate', 'showInColumnChooser']
  const mergeReservedColumns = (columnConfig) => {
    const combinedColumnData = []

    // 1. Add reserved columns first in fixed order (blank, Title, then reserved metadata)
    for (const reservedColumn of reservedColumns.value) {
      const existingColumn = columnConfig.find(col => col.dataField === reservedColumn.dataField)
      const merged = { ...reservedColumn, ...existingColumn }

      for (const key of protectedKeys) {
        if (key in reservedColumn) {
          merged[key] = reservedColumn[key]
        }
      }

      if (merged.fixed === false) {
        delete merged.fixedPosition
      }

      combinedColumnData.push(merged)
    }

    // 2. Add metadata columns (non-reserved) in user config order
    for (const userColumn of columnConfig) {
      if (!reservedDataFields.includes(userColumn.dataField) && userColumn.dataField !== 'rowNumber') {
        combinedColumnData.push(userColumn)
      }
    }

    return combinedColumnData
  }

  // TODO: consider putting reservedColumns in another file
  const reservedColumns = ref([
    {
      'dataField': "selected",
      'headerCellTemplate': "select-header-template",
      'cellTemplate': "select-template",
      'showInColumnChooser': false,
      'allowEditing': false,
      'allowFiltering': false,
      'allowSorting': false,
      'allowReordering': false,
      'allowResizing': false,
      'allowFixing': false,
      'fixed': false,
      'width': 60,
      'minWidth': 60,
      'visible': true
    },
    {
      'caption': "Title",
      'dataField': "doc_title",
      'cellTemplate': "main-doc-cell",
      'showInColumnChooser': false,
      'allowEditing': false,
      'width': 500,
      'minWidth': 75,
      'visible': true
    },
    {
      'caption': "Document Date",
      'dataField': "doc_dt",
      'dataType': "date",
      'groupInterval': "day",
      'width': 160,
      'minWidth': 100,
      'visible': true
    },
    {
      'caption': "Page Count",
      'dataField': "page_count",
      'dataType': "number",
      'allowEditing': false,
      'width': 150,
      'minWidth': 100,
      'visible': true
    },
    {
      'caption': "Has Splits",
      'dataField': "has_split",
      'dataType': "boolean",
      'allowEditing': false,
      'width': 125,
      'minWidth': 100,
      'visible': true
    }
  ])

  return {
    cabinetId,
    cabinetData,
    cabinetColumnConfig,
    userColumnConfig,
    reservedColumns,
    setCabinet,
    updateCabinetData,
    getCabinetColumnConfig,
    updateCabinetColumnConfig,
    getUserColumnConfig,
    saveUserColumnConfig
  }
})
